import { lazy, Suspense, type FC } from 'react';

const HpSharedAppBanner = lazy(
    () => import(/* webpackChunkName: "HpSharedAppBanner" */ './HpSharedAppBanner.tsx')
);

import { type HpSharedAppBanner_user$key } from './__generated__/HpSharedAppBanner_user.graphql.ts';

type Props = {
    user: HpSharedAppBanner_user$key | null | undefined;
};

export const HpSharedAppBannerLazy: FC<Props> = ({ user: userRef }) => {
    return (
        <Suspense fallback="">
            <HpSharedAppBanner user={userRef} />
        </Suspense>
    );
};
